/**
 * @func 通用函数构造
 * @author zhangfs by Atom
 * @param 2019/01/30 10:00
 */

const msgOffset = (() => {
  return (document.documentElement.clientHeight / 2) - 160
})();

const utils = {
  /**
   * @func 获取url参数列表, 加入当前路由
   **/
  getUrlParam(url) {
    url = url || window.location.href
    let uri = decodeURI(url).split('?');
    let obj = {}
    obj['route'] = uri[0].split('/#')[1]
    if (!uri[1]) return obj // 无参情况
    let nweArrobject = uri[0].split();
    let objectArr = uri[1].split('&');
    objectArr.forEach((v, i) => {
      if (v == 'TARGET_NEW') {
        let objIndex = objectArr.indexOf('TARGET_NEW');
        objectArr.splice(objIndex, 1)
        uri = objectArr.join('&');
        let aaa = uri.split();
        uri = nweArrobject.concat(aaa)
      }
    })
    let arr = uri[1].split('&')
    arr.forEach(x => {
      let kv = x.split('=')
      obj[kv[0]] = kv[1].split('#')[0]
    })
    return obj
  },
  /**
   * @func ，把对象转为拼接的字符串,用于url参数的拼接,例如?a=1b&=2$c=3
   **/
  objSerialize(obj) {
    let param = ''
    let arr = []
    for (let key in obj) {
      arr.push(key)
    }
    arr.forEach((v, i) => {
      param += i == 0 ? '?' : '&'
      param += v + '=' + obj[v]
    });
    return param
  },
  /**
   * @func 根据ua判断终端类型
   **/
  isPC() {
    if (navigator.userAgent.match(/(pad|ipad)/i)) {
      return !(navigator.userAgent.indexOf('com.longfor') > -1 || navigator.userAgent.indexOf('kuaiyixing.CheYiXing') > -1);
    }

    return (!navigator.userAgent.match(/(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i));
  },
  isIos() {
    let u = navigator.userAgent;
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  },

  /**
   *
   * @func 判断是否为ie浏览器
   * @param
   */
  isIE() {
    return !!window.ActiveXObject || "ActiveXObject" in window
  },

  /**
   * @func 千分位金额格式化, 默认保留两位小数
   * @param s-要格式化的数字, n-保留几位小数
   **/
  SlyamountFormat(s, n) {
    if (!s || isNaN(s)) return s || ''
    n = typeof (n) == 'string' ? n : 2
    s = parseFloat(`${s}`.trim().replace(/[^\d\.-]/g, '')).toFixed(n) + ''
    let l = s.split('.')[0].split('').reverse()
    let t = ''
    l.forEach((x, i) => t += x + ((i + 1) % 3 == 0 && i + 1 != l.length ? ',' : ''))
    let z = t.split('').reverse().join('')
    if (n == 0) return z
    let f = s.split('.')[1]
    return `${z}.${f}`
  },

  /**
   * @func 限制文本框输入emoji表情
   **/

  noEmoji(text) {
    if (typeof (text) !== 'string')
      var reg2 = /([\u00A9\u00AE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9-\u21AA\u231A-\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA-\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614-\u2615\u2618\u261D\u2620\u2622-\u2623\u2626\u262A\u262E-\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665-\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B-\u269C\u26A0-\u26A1\u26AA-\u26AB\u26B0-\u26B1\u26BD-\u26BE\u26C4-\u26C5\u26C8\u26CE-\u26CF\u26D1\u26D3-\u26D4\u26E9-\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733-\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934-\u2935\u2B05-\u2B07\u2B1B-\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70-\uDD71\uDD7E-\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01-\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50-\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96-\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF])|(\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F-\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95-\uDD96\uDDA4-\uDDA5\uDDA8\uDDB1-\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB-\uDEEC\uDEF0\uDEF3-\uDEF6])|(\uD83E[\uDD10-\uDD1E\uDD20-\uDD27\uDD30\uDD33-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4B\uDD50-\uDD5E\uDD80-\uDD91\uDDC0])/g;
    return text.replace(reg2, '')
  },


  /**
   * @func 弱提示消息窗口
   **/
  notify(vm, type, info, title, duration = 2500) {
    let tit = type == 'success' ? '成功' : type == 'error' ? '错误' : type == 'warning' ? '警告' : '提示'
    let msg = type == 'success' ? '操作成功' : type == 'error' ? '操作失败' : ''
    vm.$notify({
      title: title || tit,
      message: info || msg,
      type: type,
      duration: duration
    });
  },

  /**
   * @func 强提示弹窗
   * @param vm
   * @param info
   * @param cb
   * @param title
   * @param btnName
   * @param type: alert-提示框，comfirm-确认框，prompt-意见框
   * @tip: 功能复杂请使用dialog
   **/
  alert(vm, info = '操作失败', cb = function () {}, title = '提示', btnName = '确定', type = 'alert') {
    type != 'comfirm' && type != 'prompt' && (type = 'alert')
    vm.$alert(info, title, {
      confirmButtonText: btnName,
      callback: action => {
        cb && cb()
      }
    })
  },

  /**
   * @func 弱提示消息盒子
   **/
  message(vm, type = 'info', message = "", duration = 2000, offset = msgOffset) {
    let msg = type == 'success' ? '操作成功' : type == 'error' ? '操作失败' : ''

    let isPc = vm.$store.state.isPc
    if (isPc) {
      vm.$message({
        message: message || msg,
        type: type,
        duration: duration,
        customClass: "el-message--maia-light",
        offset: offset
      });
    } else {
      let typeTiptoast = type == 'success' ? true : type == 'error' ? false : ''
      vm.$tiptoast(message, typeTiptoast, duration);
    }
  },
  /**
   * @func 抛出错误，便于调试
   * @param vm-实例对象，可不传，此时页面不会提示错误。 e-异常对象，控制台打印错误信息
   **/
  throwError(vm, e) {
    arguments.length == 1 && (e = vm)
    arguments.length == 2 && this.notify(vm, 'error', e.message)
    console.info(`错误名称: ${e.name}\n错误描述: ${e.message}\n错误堆栈: ${e.stack}`)
  },
  /**
   * @func 获取cookie
   */
  getCookie() {
    //可以搜索RegExp和match进行学习
    var arr,
      reg = new RegExp("(^| )" + 'CASTGC' + "=([^;]*)(;|$)");
    if ((arr = document.cookie.match(reg))) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  },
  setcookie(name, value) {
    if (value == 'null' || value == 'undefined') return
    // var days = 1;
    var exp = new Date();
    //写入Cookie  ，toGMTstring将时间转换成字符串。
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString;
  },
  // 判断数组中的值是否都相等
  isAllEqual(array) {
    if (array.length > 0) {
      return !array.some(function (value, index) {
        return value !== array[0];
      });
    } else {
      return true;
    }
  },
  dateTimeToStr1(date) {
    return (
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      date.getDate() +
      " " +
      date.getHours() +
      "-" +
      date.getMinutes() +
      "-" +
      date.getSeconds()
    );
  },
  /**
   * 相差几个月（默认是3个月）
   * @param {*} val
   * val:1 [2020-11-02, 2020-12-02]
   */
  getLastMonth(val = 3) {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth() + 1;//0-11表示1-12月
    var day = now.getDate();
    var dateObj = {};
    dateObj.now = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    var nowMonthDay = new Date(year, month, 0).getDate();    //当前月的总天数
    if (month - 1 <= 0) { //如果是1月，年数往前推一年<br>　
      let d = day < 10 ? '0' + day : day
      dateObj.last = (year - 1) + '-' + 12 + '-' + d;
    } else {
      var lastMonthDay = new Date(year, (parseInt(month) - val), 0).getDate();
      let m = month - val < 10 ? '0' + (month - val) : month - val
      if (lastMonthDay < day) {    //3个月前所在月的总天数小于现在的天日期
        if (day < nowMonthDay) {        //当前天日期小于当前月总天数
          let d = (lastMonthDay - (nowMonthDay - day)) < 10 ? '0' + (lastMonthDay - (nowMonthDay - day)) : (lastMonthDay - (nowMonthDay - day))
          dateObj.last = year + '-' + m + '-' + d;
        } else {
          let d = lastMonthDay < 10 ? '0' + lastMonthDay : lastMonthDay
          dateObj.last = year + '-' + m + '-' + d;
        }
      } else {
        let d = day < 10 ? '0' + day : day
        dateObj.last = year + '-' + m + '-' + d;
      }
    }
    return dateObj;
  },
  /**
   * @func 下载文件
   * @param blobParts: blob对象
   * @param filename: 下载后的文件名
   **/
   downloadFile(blobParts,filename) {
    var blob = new Blob(blobParts);
    var downloadElement = document.createElement('a');
    var href = window.URL.createObjectURL(blob); //创建下载的链接
    downloadElement.href = href;
    downloadElement.download = filename; //下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); //点击下载
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
  },
}

export default utils



// WEBPACK FOOTER //
// ./src/assets/js/utils.js